import { render, staticRenderFns } from "./SkeletonRect.vue?vue&type=template&id=5fef261c&scoped=true&"
import script from "./SkeletonRect.vue?vue&type=script&lang=js&"
export * from "./SkeletonRect.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonRect.vue?vue&type=style&index=0&id=5fef261c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef261c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fef261c')) {
      api.createRecord('5fef261c', component.options)
    } else {
      api.reload('5fef261c', component.options)
    }
    module.hot.accept("./SkeletonRect.vue?vue&type=template&id=5fef261c&scoped=true&", function () {
      api.rerender('5fef261c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/components/crash-bet/SkeletonRect.vue"
export default component.exports